import { useTheme } from "@/contexts/ThemeContext";
import { cn } from "@/lib/utils";

interface ThemePreviewProps {
  themeId: string;
  themeName: string;
  onClick: () => void;
  isActive: boolean;
}

export function ThemePreview({
  themeId,
  themeName,
  onClick,
  isActive,
}: ThemePreviewProps) {
  const { mode } = useTheme();
  const isDarkMode = mode === "dark";
  // Always scope the swatch — including Default — so the card shows that
  // palette even when the live page is on a different theme.
  const themeClass = `theme-${themeId}`;
  const modeClass = isDarkMode ? "dark" : "";

  return (
    <button
      type="button"
      className={cn(
        "relative w-full overflow-hidden rounded-xl border text-left transition-colors hover:bg-muted/30",
        isActive ? "border-primary ring-1 ring-primary/30" : "border-border",
      )}
      onClick={onClick}
      aria-pressed={isActive}
      aria-label={themeName}
    >
      <div className={`${themeClass} ${modeClass} theme-preview`}>
        <div className="theme-preview-header">
          <span>{themeName}</span>
        </div>
        <div className="theme-preview-content">
          <div className="theme-preview-sidebar">
            <div className="theme-preview-sidebar-item" />
            <div className="theme-preview-sidebar-item" />
            <div className="theme-preview-sidebar-item" />
          </div>
          <div className="theme-preview-main">
            <div className="theme-preview-title" />
            <div className="theme-preview-text" />
            <div className="theme-preview-text short" />
            <div className="theme-preview-actions">
              <div className="theme-preview-button" />
              <div className="theme-preview-button secondary" />
            </div>
          </div>
        </div>
      </div>
    </button>
  );
}
